import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actionId"];
import { useAssetActions } from 'asset-actions-lib/context/AssetActionsContext';
import AssetActionButtonComponent from 'asset-actions-lib/internal/components/AssetActionButtonComponent';
import { useMemo } from 'react';
import { useDefaultButtonProps } from '../hooks/useDefaultButtonProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function AssetActionButton(_ref) {
  let {
      actionId
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const defaultButtonProps = useDefaultButtonProps();
  const {
    handleActionClick,
    actionsWithOverrides
  } = useAssetActions();
  const action = useMemo(() => actionsWithOverrides ? actionsWithOverrides.find(({
    id
  }) => id === actionId) : undefined, [actionsWithOverrides, actionId]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: action ? /*#__PURE__*/_jsx(AssetActionButtonComponent, {
      action: action,
      onClick: handleActionClick || (() => {}),
      uiButtonProps: Object.assign({}, defaultButtonProps, rest)
    }) : null
  });
}